import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import CenterModal from "@ats/src/components/modals/CenterModal";
import Button from "@ats/src/components/shared/Button";
import Icon from "@ats/src/components/shared/Icon";

type Props = {
  jobId: number;
  onCancel: () => void;
};

function RunPlatoAddDescriptionModal({ jobId, onCancel }: Props) {
  return (
    <CenterModal headerTitleText="Add a job description first" onCancel={onCancel}>
      <Styled.Body>
        Plato reviews each candidate against the criteria it reads from your job description.
        This job doesn't have one yet, so there's nothing to score against.
      </Styled.Body>

      <Styled.Statement>
        <Icon name="file-text" />
        <span>
          Write a specific job description with clear requirements in Job setup. Plato scores
          candidates against the criteria it reads from your description, so well-defined
          requirements mean more precise fit scores.
        </span>
      </Styled.Statement>

      <Styled.Actions>
        <Button type="internalLink" styleType="primary" link={`/jobs/${jobId}/setup/description`} onClick={onCancel}>
          Edit job description
        </Button>
        <Button type="button" styleType="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Styled.Actions>
    </CenterModal>
  );
}

RunPlatoAddDescriptionModal.propTypes = {};
RunPlatoAddDescriptionModal.defaultProps = {};

export default RunPlatoAddDescriptionModal;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Body = styled.p((props) => {
  const t: any = props.theme;
  return css`
    label: RunPlatoAddDescriptionModal_Body;
    ${t.mt(2)}
    color: ${t.dark ? t.color.gray[300] : t.color.gray[600]};
    line-height: 1.5;
  `;
});

Styled.Statement = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: RunPlatoAddDescriptionModal_Statement;
    ${[t.mt(4), t.p(3), t.rounded.md]}
    display: flex;
    gap: 0.625rem;
    border: 1px solid ${t.dark ? t.color.gray[700] : t.color.gray[200]};
    color: ${t.dark ? t.color.gray[300] : t.color.gray[600]};
    line-height: 1.5;
    ${t.text.sm}

    svg {
      flex-shrink: 0;
      margin-top: 0.0625rem;
      width: 1rem;
      height: 1rem;
      color: ${t.dark ? t.color.gray[400] : t.color.gray[500]};
    }
  `;
});

Styled.Actions = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: RunPlatoAddDescriptionModal_Actions;
    ${t.mt(5)}
    display: flex;
    gap: 0.625rem;
  `;
});
